// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-indicators li {
  background-color: rgb(7, 205, 255);
}

.carousel-indicators .active {
  background-color: rgb(242, 0, 0);
}

.carousel-control-prev {
  color: red !important;
  background-image: non;
}
/* .carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='red' viewBox='0 0 1… 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e");
} */

/* Default styling for larger screens */
.brand-one-sec .row .col {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.brand-one-sec img {
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

/* Tablet view (max-width: 768px) */
@media (max-width: 768px) {
  .brand-one-sec .row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .brand-one-sec .col {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
}

/* Mobile view (max-width: 480px) */
@media (max-width: 480px) {
  .brand-one-sec .col {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }

  .brand-one-sec img {
    width: 80%; /* Adjust image size if needed */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/brand/BrandOne.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;GAEG;;AAEH,uCAAuC;AACvC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU,EAAE,gCAAgC;EAC9C;AACF","sourcesContent":[".carousel-indicators li {\n  background-color: rgb(7, 205, 255);\n}\n\n.carousel-indicators .active {\n  background-color: rgb(242, 0, 0);\n}\n\n.carousel-control-prev {\n  color: red !important;\n  background-image: non;\n}\n/* .carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='red' viewBox='0 0 1… 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n} */\n\n/* Default styling for larger screens */\n.brand-one-sec .row .col {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.brand-one-sec img {\n  max-width: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n/* Tablet view (max-width: 768px) */\n@media (max-width: 768px) {\n  .brand-one-sec .row {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .brand-one-sec .col {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n}\n\n/* Mobile view (max-width: 480px) */\n@media (max-width: 480px) {\n  .brand-one-sec .col {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  .brand-one-sec img {\n    width: 80%; /* Adjust image size if needed */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
